// extracted by mini-css-extract-plugin
export var FeaturedNewsTag = "news-article-module--FeaturedNewsTag--ddbcf";
export var RecentBlogImage = "news-article-module--RecentBlogImage--520a6";
export var RecentBlogheading = "news-article-module--RecentBlogheading--febf6";
export var RecentadsImage = "news-article-module--RecentadsImage--d2643";
export var ScrollableSection = "news-article-module--ScrollableSection--9bd5d";
export var Tags = "news-article-module--Tags--ec6e0";
export var authorClass = "news-article-module--authorClass--d54ae";
export var authorClassSub = "news-article-module--authorClassSub--1be53";
export var blogFeaturedImage = "news-article-module--blogFeaturedImage--130bc";
export var blogTitle = "news-article-module--blogTitle--0ea9e";
export var blueDarkbutton = "news-article-module--blueDarkbutton--84c46";
export var column1 = "news-article-module--column1--b1838";
export var column2 = "news-article-module--column2--14518";
export var container = "news-article-module--container--cf070";
export var containered = "news-article-module--containered--c38c9";
export var emContainer = "news-article-module--emContainer--fd881";
export var fadeInOut = "news-article-module--fadeInOut--b7631";
export var fullContainer = "news-article-module--fullContainer--a9dc3";
export var golden = "news-article-module--golden--0f2dc";
export var hiddenOne = "news-article-module--hiddenOne--716f2";
export var imagecontainer = "news-article-module--imagecontainer--4363d";
export var loaded = "news-article-module--loaded--0d7e5";
export var makeStylesCopyContainer5 = "news-article-module--makeStyles-copyContainer-5--3d649";
export var marg = "news-article-module--marg--dd21a";
export var minTagHeight = "news-article-module--minTagHeight--75795";
export var mobileXd = "news-article-module--mobileXd--9e2d9";
export var newsContainer = "news-article-module--newsContainer--164aa";
export var newsContentContainer = "news-article-module--newsContentContainer--0d62a";
export var overlay = "news-article-module--overlay--162f8";
export var overlayHR = "news-article-module--overlayHR--fd6d8";
export var overlaytext = "news-article-module--overlaytext--69275";
export var recentNews = "news-article-module--recentNews--6412e";
export var recentNewsVertical = "news-article-module--recentNewsVertical--0cc2d";
export var slideSlide = "news-article-module--slideSlide--f4ca8";
export var sliderBlog = "news-article-module--sliderBlog--2b9b7";
export var socialShare = "news-article-module--socialShare--8050f";
export var sticky = "news-article-module--sticky--4eb70";
export var stickyClose = "news-article-module--stickyClose--490a0";
export var stickyColumn = "news-article-module--stickyColumn--ba028";
export var stickyFlexOne = "news-article-module--stickyFlexOne--4aa5b";
export var stickyFlexTwo = "news-article-module--stickyFlexTwo--b76f5";
export var title = "news-article-module--title--cbfa9";
export var weight = "news-article-module--weight--bee3a";